import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";
import enNav from "./locales/en/nav.json";
import esNav from "./locales/es/nav.json";
import enAuth from "./locales/en/auth.json";
import esAuth from "./locales/es/auth.json";
import enAdmin from "./locales/en/admin.json";
import esAdmin from "./locales/es/admin.json";
import enSettings from "./locales/en/settings.json";
import esSettings from "./locales/es/settings.json";
import enDashboard from "./locales/en/dashboard.json";
import esDashboard from "./locales/es/dashboard.json";
import enActivity from "./locales/en/activity.json";
import esActivity from "./locales/es/activity.json";
import enAnalytics from "./locales/en/analytics.json";
import esAnalytics from "./locales/es/analytics.json";
import enIdeas from "./locales/en/ideas.json";
import esIdeas from "./locales/es/ideas.json";
import enProjects from "./locales/en/projects.json";
import esProjects from "./locales/es/projects.json";
import enPieces from "./locales/en/pieces.json";
import esPieces from "./locales/es/pieces.json";
import enCalendar from "./locales/en/calendar.json";
import esCalendar from "./locales/es/calendar.json";
import enInbox from "./locales/en/inbox.json";
import esInbox from "./locales/es/inbox.json";
import enCompose from "./locales/en/compose.json";
import esCompose from "./locales/es/compose.json";
import enPalette from "./locales/en/palette.json";
import esPalette from "./locales/es/palette.json";
import enAds from "./locales/en/ads.json";
import esAds from "./locales/es/ads.json";
import enAssistant from "./locales/en/assistant.json";
import esAssistant from "./locales/es/assistant.json";
import enWizard from "./locales/en/wizard.json";
import esWizard from "./locales/es/wizard.json";
import enUi from "./locales/en/ui.json";
import esUi from "./locales/es/ui.json";
import enBrand from "./locales/en/brand.json";
import esBrand from "./locales/es/brand.json";
import enCompetitors from "./locales/en/competitors.json";
import esCompetitors from "./locales/es/competitors.json";

export const SUPPORTED_UI_LANGUAGES = ["en", "es"] as const;
export type UiLanguage = (typeof SUPPORTED_UI_LANGUAGES)[number];

export const resources = {
  en: { common: enCommon, nav: enNav, auth: enAuth, admin: enAdmin, settings: enSettings, dashboard: enDashboard, activity: enActivity, analytics: enAnalytics, ideas: enIdeas, projects: enProjects, pieces: enPieces, calendar: enCalendar, inbox: enInbox, compose: enCompose, palette: enPalette, ads: enAds, assistant: enAssistant, wizard: enWizard, ui: enUi, brand: enBrand, competitors: enCompetitors },
  es: { common: esCommon, nav: esNav, auth: esAuth, admin: esAdmin, settings: esSettings, dashboard: esDashboard, activity: esActivity, analytics: esAnalytics, ideas: esIdeas, projects: esProjects, pieces: esPieces, calendar: esCalendar, inbox: esInbox, compose: esCompose, palette: esPalette, ads: esAds, assistant: esAssistant, wizard: esWizard, ui: esUi, brand: esBrand, competitors: esCompetitors },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: SUPPORTED_UI_LANGUAGES as unknown as string[],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "content-os:lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
